/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { UserRoleDto } from '../models/user-role-dto';
import { UserRoleListDto } from '../models/user-role-list-dto';
import { userRolesCreate } from '../fn/user-roles/user-roles-create';
import { UserRolesCreate$Params } from '../fn/user-roles/user-roles-create';
import { userRolesFindAll } from '../fn/user-roles/user-roles-find-all';
import { UserRolesFindAll$Params } from '../fn/user-roles/user-roles-find-all';
import { userRolesGet } from '../fn/user-roles/user-roles-get';
import { UserRolesGet$Params } from '../fn/user-roles/user-roles-get';
import { userRolesUpdate } from '../fn/user-roles/user-roles-update';
import { UserRolesUpdate$Params } from '../fn/user-roles/user-roles-update';

@Injectable({ providedIn: 'root' })
export class UserRolesApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userRolesFindAll()` */
  static readonly UserRolesFindAllPath = '/user-roles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRolesFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRolesFindAll$Response(params?: UserRolesFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserRoleListDto>>> {
    const obs = userRolesFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRolesFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRolesFindAll(params?: UserRolesFindAll$Params, context?: HttpContext): Observable<Array<UserRoleListDto>> {
    const resp = this.userRolesFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<UserRoleListDto>>): Array<UserRoleListDto> => r.body)
    );
  }

  /** Path part for operation `userRolesCreate()` */
  static readonly UserRolesCreatePath = '/user-roles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRolesCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRolesCreate$Response(params: UserRolesCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = userRolesCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRolesCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRolesCreate(params: UserRolesCreate$Params, context?: HttpContext): Observable<void> {
    const resp = this.userRolesCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userRolesGet()` */
  static readonly UserRolesGetPath = '/user-roles/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRolesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRolesGet$Response(params: UserRolesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRoleDto>> {
    const obs = userRolesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRolesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRolesGet(params: UserRolesGet$Params, context?: HttpContext): Observable<UserRoleDto> {
    const resp = this.userRolesGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserRoleDto>): UserRoleDto => r.body)
    );
  }

  /** Path part for operation `userRolesUpdate()` */
  static readonly UserRolesUpdatePath = '/user-roles/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRolesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRolesUpdate$Response(params: UserRolesUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = userRolesUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRolesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRolesUpdate(params: UserRolesUpdate$Params, context?: HttpContext): Observable<void> {
    const resp = this.userRolesUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
